import { getIsTrainIncident } from '@rsos/base-utils';
import { TRAIN_INCIDENT_ALERT_TYPE } from '@rsos/constants/alertTypes';
import TrainCustomContent from './componentsByIncidentType/trainCustomComponents/AccordionContent/AccordionContent';
import TrainCustomHeader from './componentsByIncidentType/trainCustomComponents/AccordionHeader/AccordionHeader';
import AccordionSectionTitle from './componentsByIncidentType/trainCustomComponents/AccordionSectionTitle';

const getIncidentCategory = incidentType => {
  if (getIsTrainIncident(incidentType)) {
    return TRAIN_INCIDENT_ALERT_TYPE;
  }

  return 'DEFAULT';
};

export const fetchAccordionTitle = (incidentType, title) => {
  const incidentCategory = getIncidentCategory(incidentType);
  switch (incidentCategory) {
    case TRAIN_INCIDENT_ALERT_TYPE: {
      return <AccordionSectionTitle title={title} />;
    }
    default:
      return '';
  }
};

export const fetchAccordionHeader = (incidentType, data) => {
  const incidentCategory = getIncidentCategory(incidentType);
  switch (incidentCategory) {
    case TRAIN_INCIDENT_ALERT_TYPE: {
      return <TrainCustomHeader data={data} />;
    }
    default:
      return '';
  }
};

export const fetchAccordionContent = (incidentType, props) => {
  const incidentCategory = getIncidentCategory(incidentType);
  switch (incidentCategory) {
    case TRAIN_INCIDENT_ALERT_TYPE: {
      return <TrainCustomContent props={props} />;
    }
    default:
      return <></>;
  }
};

export const fetchCustomAccordionStyle = incidentType => {
  const incidentCategory = getIncidentCategory(incidentType);
  switch (incidentCategory) {
    case TRAIN_INCIDENT_ALERT_TYPE:
      return {
        borderRadius: '5px',
        overflow: 'hidden',
      };
    default:
      return null;
  }
};

export const fetchDataName = incidentType => {
  if (getIsTrainIncident(incidentType)) {
    return 'accordion-train-car-information';
  }
  return 'custom-accordion-ellington';
};
